import { Graphics } from "pixi.js";
import { gsap } from "gsap";

export class BurstParticle extends Graphics {
  constructor({
    x,
    y,
    color,
    angle,
    distance = 60,
    size = 7,
    duration = 1.45,
  }: {
    x: number;
    y: number;
    color: number;
    angle: number;
    distance?: number;
    size?: number;
    duration?: number;
  }) {
    super();
    this.circle(0, 0, size).fill({ color, alpha: 1 });
    this.x = x;
    this.y = y;
    this.alpha = 1;
    this.blendMode = "add";

    // add some random variation to the angle for a more natural burst look
    const xAngle = angle + (Math.random() - 0.5) * (Math.PI / 2);
    const yAngle = angle + (Math.random() - 0.5) * (Math.PI / 2);

    const xDistance = distance * (4 * (Math.random() * 0.5)); // add some random variation to the distance
    const yDistance = distance * (4 * (Math.random() * 0.5)); // add some random variation to the distance

    const jitteredDuration = duration + Math.random(); // add some random variation to the duration

    gsap.to(this, {
      x: x + Math.cos(xAngle) * xDistance * jitteredDuration,
      y: y + Math.sin(yAngle) * yDistance * jitteredDuration,
      alpha: 0,
      duration: jitteredDuration,
      ease: "power2.out",
      onComplete: () => {
        if (!this.destroyed) this.destroy();
      },
    });

    gsap.to(this.scale, {
      x: 0.1 * jitteredDuration,
      y: 0.1 * jitteredDuration,
      duration: jitteredDuration,
      ease: "power2.in",
    });
  }
}

export default BurstParticle;
